import { finalize } from 'rxjs/operators';
import { ticketRequestError } from '../../ticket-form.utils';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';

@Component({
  selector: 'app-TicketCategoryEdit',
  templateUrl: './TicketCategoryEdit.component.html',
  styleUrls: ['./TicketCategoryEdit.component.scss', '../../ticket-shared.css']
})
export class TicketCategoryEditComponent implements OnInit {
  ErrorMessage = '';
  EditRecord:Number

  constructor(
    private TicketCategory_Service:TicketCategoryService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditTicketCategory=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null, [Validators.required, Validators.pattern(/\S/)]),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    

    this.Nav_Service.CheckValidPage(1113).subscribe(
      data=>{
        this.InProccessing = true;
        this.TicketCategory_Service.GetSingle(this.EditRecord).pipe(finalize(() => this.InProccessing = false)).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
          }, error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
        )
      }
      ,error=>{
        this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage);
      }
    )

  }

    //#region  Form Add

    EditTicketCategory:FormGroup;

    get_Form_Id(){
      return this.EditTicketCategory.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditTicketCategory.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditTicketCategory(){
    if (this.InProccessing) return;
    this.ErrorMessage = '';
    if (this.EditTicketCategory.invalid || !(Number(this.get_Form_Id().value) > 0)) { this.EditTicketCategory.markAllAsTouched(); return; }
    const record = Empty_General_Interface();
    record.id = Number(this.get_Form_Id().value);
    record.title = this.get_Form_Title().value.trim();
    this.InProccessing = true;
    this.TicketCategory_Service.EditTicketCategory(record).pipe(finalize(() => this.InProccessing = false)).subscribe({
      next: data => {
        if (data.id === -2) { this.ErrorMessage = 'عنوان وارد شده در لیست وجود دارد.'; return; }
        this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد');
      },
      error: error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
    });
  }
}
